function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "website_v2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "step1+experiences",
  transform: "translate(-268.000000, -287.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(269.000000, 288.000000)"
}, React.createElement("g", {
  id: "Group-6"
}, React.createElement("rect", {
  id: "Rectangle",
  strokeOpacity: 0.2,
  stroke: "#142428",
  x: 0,
  y: 0,
  width: 40,
  height: 40,
  rx: 20
}), React.createElement("polygon", {
  id: "Polygon",
  fillOpacity: 0.5,
  fill: "#142428",
  fillRule: "nonzero",
  points: "13.75 20.975 13.75 18.975 25.75 18.975 25.75 20.975"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ico_less_button.a43966a3.svg";
export { SvgComponent as ReactComponent };